// extracted by mini-css-extract-plugin
export var brandLogo = "MainMenu-module--brand-logo--f1a37";
export var desktopCompact = "MainMenu-module--desktop-compact--5e304";
export var hamburger = "MainMenu-module--hamburger--0f4fe";
export var header = "MainMenu-module--header--5c097";
export var headerContainer = "MainMenu-module--header-container--f3456";
export var innerPrimaryNavCta = "MainMenu-module--inner-primary-nav-cta--ebd21";
export var mainMenu = "MainMenu-module--main-menu--3dd1d";
export var mobileSecondaryNavItems = "MainMenu-module--mobile-secondary-nav-items--3f2b4";
export var open = "MainMenu-module--open--1f1bf";
export var primaryNavContainer = "MainMenu-module--primary-nav-container--aa57d";
export var primaryNavCta = "MainMenu-module--primary-nav-cta--bf285";
export var scrollWrapper = "MainMenu-module--scroll-wrapper--46749";
export var transparent = "MainMenu-module--transparent--23d84";
export var transparentSticky = "MainMenu-module--transparent-sticky--b4a56";